var map = {
	"./Spectre/1.png": 54610,
	"./Spectre/10.png": 46920,
	"./Spectre/11.png": 40785,
	"./Spectre/12.png": 36026,
	"./Spectre/13.png": 83779,
	"./Spectre/14.png": 7532,
	"./Spectre/15.png": 59797,
	"./Spectre/16.png": 74046,
	"./Spectre/17.png": 26535,
	"./Spectre/18.png": 25440,
	"./Spectre/19.png": 3561,
	"./Spectre/2.png": 61673,
	"./Spectre/20.png": 7565,
	"./Spectre/21.png": 51268,
	"./Spectre/22.png": 5919,
	"./Spectre/23.png": 25942,
	"./Spectre/24.png": 25769,
	"./Spectre/25.png": 54592,
	"./Spectre/26.png": 32923,
	"./Spectre/27.png": 35058,
	"./Spectre/28.png": 64213,
	"./Spectre/29.png": 95116,
	"./Spectre/3.png": 90496,
	"./Spectre/30.png": 32034,
	"./Spectre/31.png": 53163,
	"./Spectre/32.png": 99664,
	"./Spectre/33.png": 96569,
	"./Spectre/34.png": 3494,
	"./Spectre/35.png": 26159,
	"./Spectre/36.png": 7252,
	"./Spectre/37.png": 28381,
	"./Spectre/38.png": 94314,
	"./Spectre/39.png": 49523,
	"./Spectre/4.png": 41823,
	"./Spectre/40.png": 35823,
	"./Spectre/41.png": 13158,
	"./Spectre/42.png": 38045,
	"./Spectre/43.png": 16916,
	"./Spectre/44.png": 62827,
	"./Spectre/45.png": 41698,
	"./Spectre/46.png": 6233,
	"./Spectre/47.png": 9328,
	"./Spectre/48.png": 59863,
	"./Spectre/49.png": 16846,
	"./Spectre/5.png": 45494,
	"./Spectre/50.png": 76644,
	"./Spectre/51.png": 2797,
	"./Spectre/52.png": 12118,
	"./Spectre/53.png": 90207,
	"./Spectre/54.png": 31552,
	"./Spectre/55.png": 86377,
	"./Spectre/56.png": 21234,
	"./Spectre/57.png": 86587,
	"./Spectre/58.png": 90348,
	"./Spectre/59.png": 73237,
	"./Spectre/6.png": 27117,
	"./Spectre/60.png": 48121,
	"./Spectre/61.png": 41872,
	"./Spectre/62.png": 13163,
	"./Spectre/63.png": 92034,
	"./Spectre/64.png": 96285,
	"./Spectre/65.png": 63252,
	"./Spectre/66.png": 37743,
	"./Spectre/67.png": 98726,
	"./Spectre/68.png": 33921,
	"./Spectre/69.png": 12792,
	"./Spectre/7.png": 87172,
	"./Spectre/70.png": 23710,
	"./Spectre/71.png": 99495,
	"./Spectre/72.png": 32460,
	"./Spectre/73.png": 44085,
	"./Spectre/8.png": 44835,
	"./Spectre/9.png": 43610,
	"./bg/0.png": 1788,
	"./bg/1.png": 54053,
	"./bg/10.png": 28449,
	"./bg/11.png": 90968,
	"./bg/12.png": 2931,
	"./bg/13.png": 71018,
	"./bg/14.png": 41445,
	"./bg/15.png": 5532,
	"./bg/16.png": 13111,
	"./bg/17.png": 13614,
	"./bg/18.png": 3001,
	"./bg/19.png": 96752,
	"./bg/2.png": 26222,
	"./bg/20.png": 58028,
	"./bg/21.png": 93941,
	"./bg/22.png": 8190,
	"./bg/23.png": 60679,
	"./bg/24.png": 81064,
	"./bg/25.png": 91281,
	"./bg/26.png": 70170,
	"./bg/27.png": 17923,
	"./bg/28.png": 74052,
	"./bg/29.png": 27949,
	"./bg/3.png": 25719,
	"./bg/30.png": 85015,
	"./bg/31.png": 95022,
	"./bg/32.png": 13797,
	"./bg/33.png": 79932,
	"./bg/34.png": 79891,
	"./bg/35.png": 29130,
	"./bg/36.png": 78113,
	"./bg/37.png": 5400,
	"./bg/38.png": 7055,
	"./bg/39.png": 21958,
	"./bg/4.png": 3576,
	"./bg/40.png": 19466,
	"./bg/41.png": 70227,
	"./bg/42.png": 95736,
	"./bg/43.png": 68449,
	"./bg/44.png": 85358,
	"./bg/45.png": 75351,
	"./bg/46.png": 70268,
	"./bg/47.png": 4133,
	"./bg/48.png": 3266,
	"./bg/49.png": 66923,
	"./bg/5.png": 24705,
	"./bg/50.png": 84917,
	"./bg/51.png": 73292,
	"./bg/52.png": 23975,
	"./bg/53.png": 48190,
	"./bg/54.png": 92753,
	"./bg/55.png": 44360,
	"./bg/56.png": 22691,
	"./bg/57.png": 32858,
	"./bg/58.png": 85741,
	"./bg/59.png": 22500,
	"./bg/6.png": 83626,
	"./bg/60.png": 66352,
	"./bg/61.png": 72601,
	"./bg/62.png": 32866,
	"./bg/63.png": 53995,
	"./bg/64.png": 4084,
	"./bg/65.png": 20765,
	"./bg/66.png": 39558,
	"./bg/67.png": 78575,
	"./bg/68.png": 53624,
	"./bg/69.png": 74753,
	"./bg/7.png": 99187,
	"./bg/70.png": 11067,
	"./bg/71.png": 62066,
	"./bg/72.png": 27209,
	"./bg/73.png": 56032,
	"./bg/74.png": 31039,
	"./bg/75.png": 52950,
	"./bg/8.png": 73268,
	"./bg/9.png": 94397,
	"./black.jpg": 76667,
	"./cross.png": 17198,
	"./flags/country/ad.png": 92102,
	"./flags/country/ae.png": 73647,
	"./flags/country/af.png": 52180,
	"./flags/country/ag.png": 89661,
	"./flags/country/ai.png": 94451,
	"./flags/country/al.png": 21486,
	"./flags/country/am.png": 4631,
	"./flags/country/ao.png": 32965,
	"./flags/country/aq.png": 77019,
	"./flags/country/ar.png": 15040,
	"./flags/country/as.png": 93161,
	"./flags/country/at.png": 53078,
	"./flags/country/au.png": 50015,
	"./flags/country/aw.png": 67053,
	"./flags/country/ax.png": 9274,
	"./flags/country/az.png": 20168,
	"./flags/country/ba.png": 35690,
	"./flags/country/bb.png": 66273,
	"./flags/country/bd.png": 77783,
	"./flags/country/be.png": 48558,
	"./flags/country/bf.png": 2565,
	"./flags/country/bg.png": 19676,
	"./flags/country/bh.png": 45515,
	"./flags/country/bi.png": 8034,
	"./flags/country/bj.png": 64121,
	"./flags/country/bl.png": 70095,
	"./flags/country/bm.png": 31078,
	"./flags/country/bn.png": 12285,
	"./flags/country/bo.png": 79252,
	"./flags/country/bq.png": 78874,
	"./flags/country/br.png": 87185,
	"./flags/country/bs.png": 47240,
	"./flags/country/bt.png": 38759,
	"./flags/country/bv.png": 36821,
	"./flags/country/bw.png": 70284,
	"./flags/country/by.png": 1170,
	"./flags/country/bz.png": 49961,
	"./flags/country/ca.png": 34769,
	"./flags/country/cc.png": 48035,
	"./flags/country/cd.png": 17868,
	"./flags/country/cf.png": 98654,
	"./flags/country/cg.png": 86343,
	"./flags/country/ch.png": 20339,
	"./flags/country/ci.png": 97545,
	"./flags/country/ck.png": 97755,
	"./flags/country/cl.png": 87812,
	"./flags/country/cm.png": 30317,
	"./flags/country/cn.png": 23286,
	"./flags/country/co.png": 1375,
	"./flags/country/cr.png": 83274,
	"./flags/country/cu.png": 50149,
	"./flags/country/cv.png": 79790,
	"./flags/country/cw.png": 25367,
	"./flags/country/cx.png": 5456,
	"./flags/country/cy.png": 11705,
	"./flags/country/cz.png": 55618,
	"./flags/country/de.png": 6516,
	"./flags/country/dj.png": 32435,
	"./flags/country/dk.png": 93578,
	"./flags/country/dm.png": 48828,
	"./flags/country/do.png": 90094,
	"./flags/country/dz.png": 55779,
	"./flags/country/ec.png": 42293,
	"./flags/country/ee.png": 3363,
	"./flags/country/eg.png": 15953,
	"./flags/country/eh.png": 4022,
	"./flags/country/er.png": 96412,
	"./flags/country/es.png": 25829,
	"./flags/country/et.png": 41162,
	"./flags/country/fi.png": 31150,
	"./flags/country/fj.png": 42629,
	"./flags/country/fk.png": 6716,
	"./flags/country/fm.png": 72202,
	"./flags/country/fo.png": 8504,
	"./flags/country/fr.png": 76717,
	"./flags/country/ga.png": 24301,
	"./flags/country/gb-eng.png": 99009,
	"./flags/country/gb-nir.png": 49514,
	"./flags/country/gb-sct.png": 34179,
	"./flags/country/gb-wls.png": 29277,
	"./flags/country/gb.png": 10326,
	"./flags/country/gd.png": 72288,
	"./flags/country/ge.png": 50409,
	"./flags/country/gf.png": 19442,
	"./flags/country/gg.png": 34267,
	"./flags/country/gh.png": 54380,
	"./flags/country/gi.png": 90293,
	"./flags/country/gl.png": 77416,
	"./flags/country/gm.png": 87633,
	"./flags/country/gn.png": 66522,
	"./flags/country/gp.png": 9428,
	"./flags/country/gq.png": 46909,
	"./flags/country/gr.png": 49350,
	"./flags/country/gs.png": 30895,
	"./flags/country/gt.png": 45520,
	"./flags/country/gu.png": 51769,
	"./flags/country/gw.png": 75691,
	"./flags/country/gy.png": 90213,
	"./flags/country/hk.png": 82438,
	"./flags/country/hm.png": 78608,
	"./flags/country/hn.png": 8779,
	"./flags/country/hr.png": 90119,
	"./flags/country/ht.png": 20721,
	"./flags/country/hu.png": 10504,
	"./flags/country/id.png": 85214,
	"./flags/country/ie.png": 37703,
	"./flags/country/il.png": 90998,
	"./flags/country/im.png": 87935,
	"./flags/country/in.png": 51076,
	"./flags/country/io.png": 4973,
	"./flags/country/iq.png": 32371,
	"./flags/country/ir.png": 36760,
	"./flags/country/is.png": 57889,
	"./flags/country/it.png": 59406,
	"./flags/country/je.png": 46566,
	"./flags/country/jm.png": 19630,
	"./flags/country/jo.png": 4540,
	"./flags/country/jp.png": 59163,
	"./flags/country/ke.png": 15181,
	"./flags/country/kg.png": 37215,
	"./flags/country/kh.png": 73800,
	"./flags/country/ki.png": 22193,
	"./flags/country/km.png": 14357,
	"./flags/country/kn.png": 77630,
	"./flags/country/kp.png": 67024,
	"./flags/country/kr.png": 85122,
	"./flags/country/kw.png": 79247,
	"./flags/country/ky.png": 50305,
	"./flags/country/kz.png": 1322,
	"./flags/country/la.png": 8424,
	"./flags/country/lb.png": 93699,
	"./flags/country/lc.png": 76122,
	"./flags/country/li.png": 39360,
	"./flags/country/lk.png": 3474,
	"./flags/country/lr.png": 70355,
	"./flags/country/ls.png": 31498,
	"./flags/country/lt.png": 16165,
	"./flags/country/lu.png": 86748,
	"./flags/country/lv.png": 87383,
	"./flags/country/ly.png": 20496,
	"./flags/country/ma.png": 44127,
	"./flags/country/mc.png": 73069,
	"./flags/country/md.png": 91506,
	"./flags/country/me.png": 62888,
	"./flags/country/mf.png": 85472,
	"./flags/country/mg.png": 40297,
	"./flags/country/mh.png": 41406,
	"./flags/country/mk.png": 27157,
	"./flags/country/ml.png": 69210,
	"./flags/country/mm.png": 90787,
	"./flags/country/mn.png": 37576,
	"./flags/country/mo.png": 77521,
	"./flags/country/mp.png": 21414,
	"./flags/country/mq.png": 60431,
	"./flags/country/mr.png": 69588,
	"./flags/country/ms.png": 2621,
	"./flags/country/mt.png": 98370,
	"./flags/country/mu.png": 35851,
	"./flags/country/mv.png": 48208,
	"./flags/country/mw.png": 54457,
	"./flags/country/mx.png": 38894,
	"./flags/country/my.png": 68119,
	"./flags/country/mz.png": 10012,
	"./flags/country/na.png": 94878,
	"./flags/country/nc.png": 44716,
	"./flags/country/ne.png": 56858,
	"./flags/country/nf.png": 77969,
	"./flags/country/ng.png": 67752,
	"./flags/country/ni.png": 662,
	"./flags/country/nl.png": 24603,
	"./flags/country/no.png": 62624,
	"./flags/country/np.png": 52215,
	"./flags/country/nr.png": 80549,
	"./flags/country/nu.png": 10122,
	"./flags/country/nz.png": 37245,
	"./flags/country/om.png": 69817,
	"./flags/country/pa.png": 29940,
	"./flags/country/pe.png": 6000,
	"./flags/country/pf.png": 75851,
	"./flags/country/pg.png": 54722,
	"./flags/country/ph.png": 1669,
	"./flags/country/pk.png": 13518,
	"./flags/country/pl.png": 65985,
	"./flags/country/pm.png": 81368,
	"./flags/country/pn.png": 55859,
	"./flags/country/pr.png": 76191,
	"./flags/country/ps.png": 79862,
	"./flags/country/pt.png": 79689,
	"./flags/country/pw.png": 88978,
	"./flags/country/py.png": 49036,
	"./flags/country/qa.png": 50779,
	"./flags/country/re.png": 67966,
	"./flags/country/ro.png": 42276,
	"./flags/country/rs.png": 67928,
	"./flags/country/ru.png": 57550,
	"./flags/country/rw.png": 42460,
	"./flags/country/sa.png": 641,
	"./flags/country/sb.png": 43210,
	"./flags/country/sc.png": 75123,
	"./flags/country/sd.png": 77724,
	"./flags/country/se.png": 13637,
	"./flags/country/sg.png": 85303,
	"./flags/country/sh.png": 68944,
	"./flags/country/si.png": 75193,
	"./flags/country/sj.png": 8610,
	"./flags/country/sk.png": 99115,
	"./flags/country/sl.png": 32852,
	"./flags/country/sm.png": 70333,
	"./flags/country/sn.png": 72774,
	"./flags/country/so.png": 54319,
	"./flags/country/sr.png": 89946,
	"./flags/country/ss.png": 54051,
	"./flags/country/st.png": 77804,
	"./flags/country/sv.png": 27966,
	"./flags/country/sx.png": 95712,
	"./flags/country/sy.png": 73833,
	"./flags/country/sz.png": 42866,
	"./flags/country/tc.png": 81842,
	"./flags/country/td.png": 63405,
	"./flags/country/tf.png": 34463,
	"./flags/country/tg.png": 56374,
	"./flags/country/th.png": 67857,
	"./flags/country/tj.png": 81123,
	"./flags/country/tk.png": 59546,
	"./flags/country/tl.png": 17493,
	"./flags/country/tm.png": 50956,
	"./flags/country/tn.png": 19431,
	"./flags/country/to.png": 31742,
	"./flags/country/tr.png": 26187,
	"./flags/country/tt.png": 92957,
	"./flags/country/tv.png": 50767,
	"./flags/country/tw.png": 11750,
	"./flags/country/tz.png": 55219,
	"./flags/country/ua.png": 99959,
	"./flags/country/ug.png": 93057,
	"./flags/country/us.png": 57109,
	"./flags/country/uy.png": 79967,
	"./flags/country/uz.png": 94692,
	"./flags/country/va.png": 37110,
	"./flags/country/vc.png": 78788,
	"./flags/country/ve.png": 46226,
	"./flags/country/vg.png": 82112,
	"./flags/country/vi.png": 8030,
	"./flags/country/vn.png": 49041,
	"./flags/country/vu.png": 11970,
	"./flags/country/wf.png": 41122,
	"./flags/country/ws.png": 86879,
	"./flags/country/xk.png": 17782,
	"./flags/country/ye.png": 91543,
	"./flags/country/yt.png": 64830,
	"./flags/country/za.png": 33202,
	"./flags/country/zm.png": 18302,
	"./flags/country/zw.png": 39540,
	"./flags/de/badenwurttemberg.png": 34344,
	"./flags/de/bayern.png": 20695,
	"./flags/de/berlin.png": 45478,
	"./flags/de/brandenburg.png": 43500,
	"./flags/de/bremen.png": 72321,
	"./flags/de/hamburg.png": 43660,
	"./flags/de/hessen.png": 97932,
	"./flags/de/niedersachsen.png": 43646,
	"./flags/de/nrw.png": 91199,
	"./flags/de/reihnlandpfalz.png": 30808,
	"./flags/de/saarland.png": 92780,
	"./flags/de/sachsen.png": 81765,
	"./flags/de/sachsenanhalt.png": 65861,
	"./flags/de/schleswigholstein.png": 6725,
	"./flags/de/thuringen.png": 26010,
	"./flags/us/ak.png": 90649,
	"./flags/us/al.png": 41254,
	"./flags/us/ar.png": 73768,
	"./flags/us/az.png": 21664,
	"./flags/us/ca.png": 6009,
	"./flags/us/co.png": 59639,
	"./flags/us/ct.png": 24644,
	"./flags/us/de.png": 97980,
	"./flags/us/fl.png": 65355,
	"./flags/us/ga.png": 20597,
	"./flags/us/hi.png": 85020,
	"./flags/us/ia.png": 47195,
	"./flags/us/id.png": 40214,
	"./flags/us/il.png": 11134,
	"./flags/us/in.png": 9388,
	"./flags/us/ks.png": 50467,
	"./flags/us/ky.png": 86601,
	"./flags/us/la.png": 88576,
	"./flags/us/ma.png": 96375,
	"./flags/us/md.png": 40490,
	"./flags/us/me.png": 91251,
	"./flags/us/mi.png": 18415,
	"./flags/us/mn.png": 22544,
	"./flags/us/mo.png": 38297,
	"./flags/us/ms.png": 53525,
	"./flags/us/mt.png": 1466,
	"./flags/us/nc.png": 91556,
	"./flags/us/nd.png": 56859,
	"./flags/us/ne.png": 58994,
	"./flags/us/nh.png": 39111,
	"./flags/us/nj.png": 88149,
	"./flags/us/nm.png": 31642,
	"./flags/us/nv.png": 72921,
	"./flags/us/ny.png": 83534,
	"./flags/us/oh.png": 65532,
	"./flags/us/ok.png": 23639,
	"./flags/us/or.png": 21558,
	"./flags/us/pa.png": 156,
	"./flags/us/ri.png": 50154,
	"./flags/us/sc.png": 3163,
	"./flags/us/sd.png": 48356,
	"./flags/us/tn.png": 87103,
	"./flags/us/tx.png": 30169,
	"./flags/us/ut.png": 11138,
	"./flags/us/va.png": 7646,
	"./flags/us/vt.png": 38451,
	"./flags/us/wa.png": 64997,
	"./flags/us/wi.png": 30749,
	"./flags/us/wv.png": 41306,
	"./flags/us/wy.png": 41165,
	"./icons/found_their.png": 5960,
	"./icons/sent.png": 23167,
	"./items/%.png": 60498,
	"./items/0.png": 4015,
	"./items/1.png": 64998,
	"./items/1Up.webp": 66350,
	"./items/2.png": 6237,
	"./items/3.png": 85108,
	"./items/4.png": 31019,
	"./items/5.png": 9890,
	"./items/6.png": 58073,
	"./items/7.png": 77520,
	"./items/8.png": 28055,
	"./items/9.png": 85038,
	"./items/Abandoned_Deck.webp": 95448,
	"./items/Abstract_Joker.webp": 55718,
	"./items/Acrobat.webp": 53766,
	"./items/Anaglyph_Deck.webp": 80612,
	"./items/Ancient_Joker.webp": 65412,
	"./items/Antivirus.png": 90640,
	"./items/Anvil.webp": 90542,
	"./items/Arcana_Pack.webp": 42658,
	"./items/Archery.webp": 69058,
	"./items/Armband_.png": 70145,
	"./items/Arrow.webp": 56697,
	"./items/Arrowhead.webp": 39851,
	"./items/Astronomer.webp": 47092,
	"./items/Audio_Tool.png": 50500,
	"./items/Balance_Badge.png": 47731,
	"./items/Balancer.webp": 10354,
	"./items/Ballon_Kid.png": 74722,
	"./items/Banana.webp": 94321,
	"./items/Banner.webp": 77574,
	"./items/Banshee.webp": 83860,
	"./items/Baron.webp": 11388,
	"./items/Baseball_Card.webp": 90031,
	"./items/Bed.webp": 84187,
	"./items/Bee_Trap.webp": 39150,
	"./items/Belt.webp": 88337,
	"./items/Besoffen_Snacken.png": 84221,
	"./items/Black_Deck.webp": 53637,
	"./items/Black_Stake.webp": 89886,
	"./items/Blackboard.webp": 95017,
	"./items/Bloodstone.webp": 17421,
	"./items/Blue_Deck.webp": 9168,
	"./items/Blue_Joker.webp": 31908,
	"./items/Blue_Shell.webp": 81325,
	"./items/Blue_Stake.webp": 64445,
	"./items/Blueprint.webp": 46551,
	"./items/Bomb_Trap.webp": 30842,
	"./items/Bones.webp": 9851,
	"./items/Bonus_Consumable_Slot.webp": 74188,
	"./items/Bonus_Discards.webp": 23423,
	"./items/Bonus_Hand.webp": 34793,
	"./items/Bonus_Joker_Slot.webp": 8152,
	"./items/Bonus_Max_Intrest.webp": 73682,
	"./items/Bonus_Money.webp": 44544,
	"./items/Bonus_Starting_Money.webp": 5487,
	"./items/Book.webp": 86893,
	"./items/Bootstraps.webp": 17171,
	"./items/Bottles.webp": 8185,
	"./items/Bowser.webp": 59150,
	"./items/Brainstorm.webp": 63853,
	"./items/Brewing.webp": 9336,
	"./items/Browser's_Castle.png": 29350,
	"./items/Bubble_Bowl.png": 86402,
	"./items/Bucket.webp": 80006,
	"./items/Buffoon_Pack.webp": 36285,
	"./items/Burglar.webp": 39945,
	"./items/Burnt_Joker.webp": 14863,
	"./items/Business_Card.webp": 68585,
	"./items/Business_Reputation.png": 49687,
	"./items/Campfire.webp": 1809,
	"./items/Canio.webp": 31722,
	"./items/Cannon.webp": 45493,
	"./items/Capture.png": 4697,
	"./items/Card_Sharp.webp": 29745,
	"./items/Cartomancer.webp": 42885,
	"./items/Cash.png": 3710,
	"./items/Castle.webp": 31704,
	"./items/Category_Fives.png": 55593,
	"./items/Category_Fours.png": 19353,
	"./items/Category_Ones.png": 25171,
	"./items/Category_Sixes.png": 83246,
	"./items/Category_Threes.png": 51759,
	"./items/Category_Twos.png": 76037,
	"./items/Cavendish.webp": 77289,
	"./items/Celestial_Pack.webp": 78118,
	"./items/Ceremonial_Dagger.webp": 98084,
	"./items/Certificate.webp": 31435,
	"./items/Challenge_Deck.webp": 6743,
	"./items/Chaos_the_Clown.webp": 15078,
	"./items/Charisma_Skill.webp": 88812,
	"./items/Checkered_Deck.webp": 94414,
	"./items/Chicot.webp": 67944,
	"./items/Chinese_Year.png": 55712,
	"./items/Choco_Mountain.webp": 41344,
	"./items/Clever_Joker.webp": 98787,
	"./items/Climb.png": 69224,
	"./items/Cloud.webp": 1633,
	"./items/Cobblestone.webp": 19254,
	"./items/Coin.png": 81816,
	"./items/Coin_Block.webp": 73823,
	"./items/Comedy_Skill.webp": 99197,
	"./items/Constellation.webp": 91183,
	"./items/Consumable_Item.webp": 53975,
	"./items/Consumable_Pack.webp": 80621,
	"./items/Cookies.webp": 4787,
	"./items/Cooking_Skill.webp": 55354,
	"./items/Crabs.png": 86418,
	"./items/Crafty_Joker.webp": 75181,
	"./items/Crazy_Joker.webp": 73137,
	"./items/Creativity.png": 72393,
	"./items/Credit_Card.webp": 25904,
	"./items/Creeper_Trap.webp": 51908,
	"./items/Cruise_Bubble.webp": 33002,
	"./items/Cutter.webp": 54711,
	"./items/D6_Tag.webp": 18577,
	"./items/DEX.png": 93268,
	"./items/Delayed_Gratification.webp": 18497,
	"./items/Demonenkönig.png": 81732,
	"./items/Devious_Joker.webp": 49179,
	"./items/Dice_Fragment.png": 36515,
	"./items/Diet_Cola.webp": 73150,
	"./items/Discovery_Check.webp": 43497,
	"./items/Donnerberge.png": 82874,
	"./items/Double.png": 58987,
	"./items/Double_Tag.webp": 85374,
	"./items/Dragon_Egg_Shard.webp": 77150,
	"./items/Drivers_License.webp": 84599,
	"./items/Droll_Joker.webp": 42531,
	"./items/Drop.webp": 4453,
	"./items/Drunkard.webp": 85071,
	"./items/Dukes.webp": 97912,
	"./items/Dusk.webp": 36457,
	"./items/Dynamo_Badge.png": 47573,
	"./items/Dämmerung.png": 78390,
	"./items/EXP.webp": 60371,
	"./items/Editor.png": 66724,
	"./items/Eishexe.png": 66750,
	"./items/Eisland.jpg": 82469,
	"./items/Emeralds.webp": 41449,
	"./items/Enchant_.webp": 70682,
	"./items/Enchanting.webp": 92259,
	"./items/Ender_Pearls.webp": 62742,
	"./items/Erosion.webp": 72433,
	"./items/Erratic_Deck.webp": 77806,
	"./items/Even_Steven.webp": 10621,
	"./items/Extractor.webp": 5092,
	"./items/Faceless_Joker.webp": 85084,
	"./items/Fans.png": 69689,
	"./items/Feather.webp": 72571,
	"./items/Feather_Badge.png": 71190,
	"./items/Feuerland.jpg": 48745,
	"./items/Fibonacci.webp": 46904,
	"./items/Filler.webp": 20442,
	"./items/FishFountain_Trap.webp": 59944,
	"./items/Fishing_Rod.webp": 132,
	"./items/Fishing_Skill.webp": 64260,
	"./items/Fitness_Skill.webp": 7462,
	"./items/Flammenkönig.png": 42116,
	"./items/Flash_Card.webp": 67641,
	"./items/Flint_and_Steel.webp": 26069,
	"./items/Flower_Cup.png": 67896,
	"./items/Flower_Pot.webp": 43767,
	"./items/Fly_.webp": 70722,
	"./items/Foil_Tag.webp": 62773,
	"./items/Fortune_Teller.webp": 16974,
	"./items/Four_Fingers.webp": 79945,
	"./items/Frappe_Snowland.png": 17796,
	"./items/Free_the_End.webp": 39060,
	"./items/Friedliche_Kiefern.png": 11419,
	"./items/Fußball_Event.png": 84471,
	"./items/Gardening_Skill.webp": 10429,
	"./items/Gautamakliff.png": 76427,
	"./items/Gbit.png": 56463,
	"./items/Geisterwald.jpg": 33190,
	"./items/Ghost.webp": 77555,
	"./items/Gift_Card.webp": 59285,
	"./items/Glass_Joker.webp": 98996,
	"./items/Glow_Up.webp": 23819,
	"./items/Gluttonous_Joker.webp": 40296,
	"./items/Gold_Stake.webp": 2599,
	"./items/Golden_Joker.webp": 73201,
	"./items/Golden_Spatula.webp": 19836,
	"./items/Golden_Ticket.webp": 60042,
	"./items/Golden_Underwear.png": 9774,
	"./items/Gourmet_Skill.webp": 62467,
	"./items/Greedy_Joker.webp": 62736,
	"./items/Green_Deck.webp": 54213,
	"./items/Green_Joker.webp": 43303,
	"./items/Green_Shell.webp": 15854,
	"./items/Green_Stake.webp": 54494,
	"./items/Gros_Michel.webp": 20028,
	"./items/Grotte_1.jpg": 12664,
	"./items/Grotte_2.png": 96343,
	"./items/Grusel.png": 69319,
	"./items/Guitar_Skill.webp": 69776,
	"./items/HOLE_IN_ONE.png": 29502,
	"./items/Hack.webp": 87577,
	"./items/Half_Joker.webp": 20165,
	"./items/Hallucination.webp": 66381,
	"./items/Halskette_.png": 70493,
	"./items/Handiness_Skill.webp": 67241,
	"./items/Hanging_Chad.webp": 4399,
	"./items/Hearts_Damage.webp": 29071,
	"./items/Heat_Badge.png": 99517,
	"./items/Helm_.png": 71436,
	"./items/Hiker.webp": 75667,
	"./items/Hit_the_Road.webp": 3200,
	"./items/Hologram.webp": 77011,
	"./items/Holographic_Tag.webp": 8815,
	"./items/Hot_Stuff.webp": 36086,
	"./items/Hüpfburg.png": 95635,
	"./items/Ice_Cream.webp": 96446,
	"./items/Ice_Trap.webp": 21111,
	"./items/Illusion.webp": 72451,
	"./items/Int.png": 69324,
	"./items/Inventory_Shuffle_Trap.webp": 97476,
	"./items/Invisible_Joker.webp": 56375,
	"./items/Item_Box.webp": 84313,
	"./items/Jemand_diskutiert_über_politik.png": 27914,
	"./items/Jemand_fängt_an_zu_streiten.png": 86515,
	"./items/Jemand_kotzt.png": 69369,
	"./items/Jemand_läuft_oberkörperfrei_rum.png": 2274,
	"./items/Jemand_mixt_was_ekliges.png": 40192,
	"./items/Jemand_schmeißt_was_runter.png": 81336,
	"./items/Jemand_verletzt_sich.png": 815,
	"./items/Jemand_verschwindet_und_keiner_weiß_wohin.png": 31461,
	"./items/Jemand_verschüttet_was.png": 6121,
	"./items/Jemand_wiederholt_sich_mehrfach.png": 9675,
	"./items/Jeon-Un.png": 3795,
	"./items/Jiggy.webp": 36598,
	"./items/Joker_Bundle.webp": 39284,
	"./items/Joker_Stencil.webp": 84736,
	"./items/Jolly_Joker.webp": 72174,
	"./items/Juggle_Tag.webp": 491,
	"./items/Juggler.webp": 93522,
	"./items/Jump_.webp": 24841,
	"./items/Kalimari_Desert.webp": 59420,
	"./items/Kill.webp": 30460,
	"./items/King_Jellyfish_Jelly.png": 67272,
	"./items/Knuckle_Badge.png": 85252,
	"./items/Koopa_Troopa_Beach.webp": 71862,
	"./items/Könisspinne.png": 66115,
	"./items/Land_der_Riesen.png": 92571,
	"./items/Lapis_Lazuli.webp": 45291,
	"./items/Lava_Trap.webp": 47080,
	"./items/Lead.webp": 59470,
	"./items/Level.webp": 66654,
	"./items/Lightning.webp": 210,
	"./items/Liquidation.webp": 87941,
	"./items/Literature_Trap.png": 95722,
	"./items/Local_Brewery.webp": 650,
	"./items/Logic_Skill.webp": 15892,
	"./items/Lost_Camper.png": 51420,
	"./items/Loyalty_Card.webp": 5037,
	"./items/Luchador.webp": 98704,
	"./items/Lucky_Cat.webp": 60059,
	"./items/Luigi.webp": 8590,
	"./items/Luigi_Raceway.webp": 97749,
	"./items/Lusty_Joker.webp": 81155,
	"./items/MGL_Trap.webp": 21262,
	"./items/MLG_Trap.webp": 82428,
	"./items/Ma-An.png": 5189,
	"./items/Mad_Joker.webp": 70610,
	"./items/Madness.webp": 86105,
	"./items/Magic_Deck.webp": 83205,
	"./items/Mail-In_Rebate.webp": 86498,
	"./items/Map2.jpg": 7795,
	"./items/Map_Unlock.png": 22294,
	"./items/Marble_Joker.webp": 31357,
	"./items/Mario_NOTUSED.webp": 34347,
	"./items/Mario_Raceway.png": 52150,
	"./items/Matador.webp": 12326,
	"./items/Mbit.png": 69353,
	"./items/Merry_Andy.webp": 46342,
	"./items/Midas_Mask.webp": 20483,
	"./items/Mime.webp": 45452,
	"./items/Mind_Badge.png": 33879,
	"./items/Mischief_Skill.webp": 41770,
	"./items/Misprint.webp": 73690,
	"./items/Mixology_Skill.webp": 87268,
	"./items/Mobs.webp": 74763,
	"./items/Mond_Event.png": 40000,
	"./items/Money_Tree.webp": 78425,
	"./items/Moo_Moo.png": 72186,
	"./items/Museum.png": 57555,
	"./items/Museum_Art.png": 60189,
	"./items/Mushroom.webp": 43258,
	"./items/Mushroom_Block.webp": 29388,
	"./items/Mushroom_Cup.png": 30308,
	"./items/Music_Disc.webp": 75601,
	"./items/Mystic_Summit.webp": 6561,
	"./items/Nacho_Tong.webp": 61486,
	"./items/Nebula_Deck.webp": 80929,
	"./items/Negative_Tag.webp": 50284,
	"./items/Nephritbucht.png": 20337,
	"./items/Netherite_Scrap.webp": 17948,
	"./items/Neunschwanz.png": 93227,
	"./items/Normal_Exit.webp": 61128,
	"./items/Oase.png": 19103,
	"./items/Obelisk.webp": 45061,
	"./items/Oberork.png": 34695,
	"./items/Observatory.webp": 20244,
	"./items/Odd_Todd.webp": 25271,
	"./items/Office_Software.png": 76631,
	"./items/Oh_Shiny.webp": 91815,
	"./items/Ohrringe_.png": 96508,
	"./items/Olympus-Odysee.png": 310,
	"./items/Omen_Globe.webp": 99430,
	"./items/Onyx_Agate.webp": 65991,
	"./items/Operating_Systems.png": 26757,
	"./items/Orange_Stake.webp": 62251,
	"./items/Orktal.png": 10082,
	"./items/Overstock_Plus.webp": 22857,
	"./items/P-Skill.png": 55899,
	"./items/PAR.png": 42310,
	"./items/Painted_Deck.webp": 11331,
	"./items/Painter.webp": 33591,
	"./items/Painting_Skill.webp": 13698,
	"./items/Pair_Attracted.png": 86718,
	"./items/Pair_Lovers.png": 17601,
	"./items/Pair_Unlock.png": 52220,
	"./items/Palette.webp": 5475,
	"./items/Pareidolia.webp": 43810,
	"./items/Patrick.png": 64625,
	"./items/Pawn.png": 69149,
	"./items/Peach.webp": 19769,
	"./items/Perkeo.webp": 35288,
	"./items/Photograph.webp": 68612,
	"./items/Photography_Skill.webp": 22505,
	"./items/Piano_Skill.webp": 57539,
	"./items/Piece.png": 13889,
	"./items/Piratenbucht.png": 29160,
	"./items/Planet_Bundle.webp": 74291,
	"./items/Planet_Tycoon.webp": 37479,
	"./items/Plasma_Deck.webp": 73902,
	"./items/Play_as_White.png": 71596,
	"./items/Plots.png": 9043,
	"./items/Pokedex.png": 3093,
	"./items/Polychrome_Tag.webp": 24371,
	"./items/Popcorn.webp": 32645,
	"./items/Porkchops.webp": 99531,
	"./items/Potion.webp": 35987,
	"./items/Power_Crystal.png": 29739,
	"./items/Products.png": 90355,
	"./items/Profit.png": 87505,
	"./items/Programming_Skill.webp": 24251,
	"./items/Progressive_Armor.webp": 69251,
	"./items/Progressive_Drift.webp": 34495,
	"./items/Progressive_Engine_ELO_Lobotomy.webp": 82897,
	"./items/Progressive_Resource_Crafting.webp": 76943,
	"./items/Progressive_Tools.webp": 83551,
	"./items/Progressive_Weapons.webp": 55669,
	"./items/Pung-Ma.png": 4956,
	"./items/Purple_Stake.webp": 98795,
	"./items/Quality.png": 80364,
	"./items/Queen.png": 5201,
	"./items/Quest-Punkte.webp": 79390,
	"./items/Rain_Badge.png": 81321,
	"./items/Rainbow_Road.webp": 62861,
	"./items/Raised_Fist.webp": 16263,
	"./items/Ramen.webp": 759,
	"./items/Random_Cookie_Multiplier.webp": 78468,
	"./items/Random_Typ_starrt_dich_an.png": 61524,
	"./items/Rare_Candy.png": 4221,
	"./items/Rare_Tag.webp": 17607,
	"./items/Raumstation.png": 85872,
	"./items/Recyclomancy.webp": 3445,
	"./items/Red_Card.webp": 78926,
	"./items/Red_Deck.webp": 94177,
	"./items/Red_Shell.webp": 69194,
	"./items/Red_Stake.webp": 93346,
	"./items/Reroll_Surplus.webp": 1067,
	"./items/Reserved_Parking.webp": 88615,
	"./items/Resource_Blocks.webp": 1203,
	"./items/Reverse Trap.jpg": 97552,
	"./items/Ride_the_Bus.webp": 57395,
	"./items/Riff-Raff.webp": 59501,
	"./items/Rocket.webp": 53116,
	"./items/Roll_Fragment.png": 24715,
	"./items/Rotator.webp": 88917,
	"./items/Roter_Wald.png": 44866,
	"./items/Rough_Gem.webp": 52133,
	"./items/Royal_Raceway.png": 57815,
	"./items/Runner.webp": 75770,
	"./items/Rüstung_.png": 54683,
	"./items/STR.png": 9058,
	"./items/Saddle.webp": 66223,
	"./items/Sand.webp": 90210,
	"./items/Sandman.png": 83605,
	"./items/Sandy.png": 27660,
	"./items/Satellite.webp": 36321,
	"./items/Scary_Face.webp": 54428,
	"./items/Schild_.png": 66953,
	"./items/Schlangenfeld.png": 96987,
	"./items/Scholar.webp": 43182,
	"./items/Schuhe_.png": 8622,
	"./items/Seance.webp": 76771,
	"./items/Secret_Exit.png": 38900,
	"./items/Security_Override_button.webp": 81884,
	"./items/Seeing_Double.webp": 31391,
	"./items/Seltzer.webp": 21413,
	"./items/Sherbet_Land.webp": 59365,
	"./items/Shield.webp": 94809,
	"./items/Shiny_Object.webp": 20087,
	"./items/Ship_Cannon.png": 3577,
	"./items/Shoot_the_Moon.webp": 21029,
	"./items/Shop_Item.jpg": 75441,
	"./items/Shortcut.webp": 20434,
	"./items/Shot.png": 54367,
	"./items/Showman.webp": 95143,
	"./items/Shulker_Box.webp": 84490,
	"./items/Silvester.png": 53911,
	"./items/Simoleon.webp": 97342,
	"./items/Sixth_Sense.webp": 61213,
	"./items/Sleep_.webp": 55976,
	"./items/Sleep_Trap.webp": 16211,
	"./items/Sleepy_Programmer.webp": 34227,
	"./items/Sly_Joker.webp": 12677,
	"./items/Smeared_Joker.webp": 14465,
	"./items/Smiley_Face.webp": 96521,
	"./items/Sock.png": 64711,
	"./items/Sock_and_Buskin.webp": 28787,
	"./items/Song.png": 13972,
	"./items/Space_Joker.webp": 83846,
	"./items/Spare_Trousers.webp": 91457,
	"./items/Spawner.webp": 71592,
	"./items/Special_Cup.png": 48391,
	"./items/Spectral_Bundle.webp": 48701,
	"./items/Spectral_Pack.webp": 88364,
	"./items/Splitter.webp": 74503,
	"./items/SpongeBob.png": 52072,
	"./items/Spyglass.webp": 5314,
	"./items/Square_Joker.webp": 26771,
	"./items/Squidward.webp": 71936,
	"./items/Stacker.webp": 22707,
	"./items/Standard_Pack.webp": 59211,
	"./items/Star.webp": 30684,
	"./items/Star_Cup.png": 10,
	"./items/Steel_Joker.webp": 5379,
	"./items/Steering_Wheel.png": 9714,
	"./items/Stone_Badge.png": 21104,
	"./items/Stone_Joker.webp": 90321,
	"./items/Storage.webp": 88369,
	"./items/Structure_Compass.webp": 44626,
	"./items/Stuntman.webp": 3132,
	"./items/Suit_Up.webp": 94691,
	"./items/Supernova.webp": 761,
	"./items/Superposition.webp": 34244,
	"./items/Swashbuckler.webp": 42868,
	"./items/Switch_Palace.webp": 96701,
	"./items/TM.png": 76422,
	"./items/Tarot_Bundle.webp": 16161,
	"./items/Tarot_Tycoon.webp": 97117,
	"./items/Tbit.png": 15370,
	"./items/Tempel.png": 9394,
	"./items/Tempel_der_Ochao.png": 30729,
	"./items/The_Deep.png": 30713,
	"./items/The_Duo.webp": 2836,
	"./items/The_Escapists.png": 8896,
	"./items/The_Family.webp": 68984,
	"./items/The_Idol.webp": 51938,
	"./items/The_Order.webp": 95816,
	"./items/The_Tribe.webp": 94076,
	"./items/The_Trio.webp": 60550,
	"./items/Throwback.webp": 22927,
	"./items/Thwimp_Trap.webp": 6509,
	"./items/Tigergeist.png": 18376,
	"./items/To_Do_List.webp": 76876,
	"./items/To_the_Moon.webp": 57019,
	"./items/Toad.webp": 59000,
	"./items/Trade_.webp": 55743,
	"./items/Trading_Card.webp": 36100,
	"./items/Trash.webp": 80618,
	"./items/Triboulet.webp": 48722,
	"./items/Trinkspiel_anfangen.png": 78887,
	"./items/Trinkspiel_erstes_zu_langweilig.png": 91045,
	"./items/Triple.png": 80575,
	"./items/Troubadour.webp": 21365,
	"./items/Tu-Young.png": 28593,
	"./items/Tunnel.webp": 43642,
	"./items/Turnpike.webp": 59260,
	"./items/Turtle_Bean.webp": 63417,
	"./items/Ultra_Ball.png": 62457,
	"./items/Uncommon_Tag.webp": 36789,
	"./items/Unlock_Alchemy_Lab.webp": 36288,
	"./items/Unlock_Bank.webp": 47807,
	"./items/Unlock_Chancemaker.webp": 60395,
	"./items/Unlock_Cursor.webp": 18687,
	"./items/Unlock_Factory.webp": 9566,
	"./items/Unlock_Farm.webp": 7093,
	"./items/Unlock_Fractal_Engine.webp": 38629,
	"./items/Unlock_Girl.png": 89210,
	"./items/Unlock_Hafen.png": 35942,
	"./items/Unlock_Javascript_Console.webp": 81236,
	"./items/Unlock_Mine.webp": 30802,
	"./items/Unlock_Portal.webp": 33627,
	"./items/Unlock_Prism.webp": 71982,
	"./items/Unlock_Shipment.webp": 91595,
	"./items/Unlock_Temple.webp": 36948,
	"./items/Unlock_Wizard_Tower.webp": 35956,
	"./items/Urzeit.png": 33118,
	"./items/Users.png": 58511,
	"./items/VIT.png": 58898,
	"./items/Vagabond.webp": 70972,
	"./items/Valentins_Event.png": 79162,
	"./items/Vampire.webp": 74038,
	"./items/Verwunschener_Wald.png": 65921,
	"./items/Very_Very_Frightening.webp": 11459,
	"./items/Video_Gaming_Skill.webp": 80655,
	"./items/Villager_Spawn_Egg.webp": 97172,
	"./items/Violin_Skill.webp": 27187,
	"./items/Vulkan.png": 17658,
	"./items/Waffe_.png": 33303,
	"./items/Wald.png": 80395,
	"./items/Walkie_Talkie.webp": 23204,
	"./items/Wario.webp": 18290,
	"./items/Wario_Stadium.png": 29337,
	"./items/Wee_Joker.webp": 27715,
	"./items/Wegbier.png": 86438,
	"./items/White_Stake.webp": 27456,
	"./items/Who_is_Cutting_Onions.webp": 44525,
	"./items/Wily_Joker.webp": 58711,
	"./items/Worms.png": 22343,
	"./items/Wrathful_Joker.webp": 62511,
	"./items/Writing_Skill.webp": 93550,
	"./items/Wüste.png": 49702,
	"./items/XP.webp": 26356,
	"./items/Yang.png": 3072,
	"./items/Yellow_Deck.webp": 21332,
	"./items/Yonghanx.png": 3277,
	"./items/Yorick.webp": 96067,
	"./items/Yoshi.webp": 63170,
	"./items/Yoshi_Egg.webp": 98912,
	"./items/Yoshi_Valley.webp": 33276,
	"./items/Zany_Joker.webp": 82296,
	"./items/Zodiac_Deck.webp": 51224,
	"./items/Zuckerland.png": 32740,
	"./items/abia.png": 79800,
	"./items/ankommen_in_der_Bar.png": 12959,
	"./items/ashley.png": 92205,
	"./items/brooke.png": 56033,
	"./items/candace.png": 73100,
	"./items/der_Dunkelheit.png": 33922,
	"./items/der_Eifersucht.png": 48267,
	"./items/der_Einsamkeit.png": 50597,
	"./items/der_Eitelkeit.png": 40621,
	"./items/der_Finsternis.png": 58520,
	"./items/der_Gier.png": 53266,
	"./items/der_Glut.png": 65453,
	"./items/der_Härte.png": 56124,
	"./items/der_Rache.png": 52392,
	"./items/der_Ratte.png": 50491,
	"./items/der_Schlacht.png": 81053,
	"./items/der_Schlangen.png": 31460,
	"./items/der_Schwärze.png": 86103,
	"./items/der_Seele.png": 3595,
	"./items/der_Vergeltung.png": 810,
	"./items/des_Affen.png": 20190,
	"./items/des_Berges.png": 83078,
	"./items/des_Büffels.png": 41950,
	"./items/des_Drachen.png": 3233,
	"./items/des_Hochmuts.png": 50191,
	"./items/des_Hundes.png": 55295,
	"./items/des_Kampfs.png": 77322,
	"./items/des_Kummers.png": 68456,
	"./items/des_Mondes.png": 79866,
	"./items/des_Mordes.png": 29590,
	"./items/des_Schattens.png": 62535,
	"./items/des_Sturzes.png": 5148,
	"./items/des_Teufels.png": 86988,
	"./items/des_Tigers.png": 61404,
	"./items/des_Todes.png": 12723,
	"./items/favourite_Friday_Night.webp": 19826,
	"./items/favourite_Holiday.png": 91879,
	"./items/favourite_Ice_Cream_Flavor.png": 12654,
	"./items/favourite_Movie_Genre.png": 50935,
	"./items/favourite_Music_Genre.webp": 4587,
	"./items/favourite_Online_Activity.png": 37000,
	"./items/favourite_Outdoor_Activity.png": 71643,
	"./items/favourite_Own_Body_Part.png": 69262,
	"./items/favourite_Pet.webp": 58453,
	"./items/favourite_Phone_App.png": 6883,
	"./items/favourite_Place_to_shop.png": 35477,
	"./items/favourite_Porn_Category.png": 87701,
	"./items/favourite_School_Subject.png": 39106,
	"./items/favourite_Sex_Position.png": 59505,
	"./items/favourite_Sunday_Morning.png": 52290,
	"./items/favourite_Theme_Park_Ride.png": 66880,
	"./items/favourite_Trait_In_Partner.png": 78684,
	"./items/favourite_Type_Of Exercise.png": 50565,
	"./items/favourite_Type_Of_Exercise.png": 90890,
	"./items/favourite_Weather.png": 67271,
	"./items/favourite_drink.png": 95229,
	"./items/fingers.webp": 69721,
	"./items/jessie.png": 82912,
	"./items/lailani.png": 82715,
	"./items/lillian.png": 8360,
	"./items/lola.png": 81513,
	"./items/nora.png": 84665,
	"./items/nothing.webp": 91381,
	"./items/outfit.png": 89310,
	"./items/polly.png": 48651,
	"./items/s_Jungle.jpg": 40158,
	"./items/sarah.png": 61362,
	"./items/shoe_gift.png": 60009,
	"./items/shoe_item.png": 24510,
	"./items/unique_gift.png": 25365,
	"./items/unique_item.png": 70442,
	"./items/zoey.png": 16124,
	"./jumpscare/7Days.jpg": 53933,
	"./jumpscare/7Days.mp3": 67070,
	"./jumpscare/Blaze.mp3": 82432,
	"./jumpscare/Blaze.webp": 32288,
	"./jumpscare/LudwigPizza.mp3": 82768,
	"./jumpscare/LudwigPizza.png": 82059,
	"./jumpscare/anime-ahh.mp3": 55222,
	"./jumpscare/anime-ahh.png": 28021,
	"./jumpscare/cave.mp3": 34779,
	"./jumpscare/cave.webp": 72001,
	"./jumpscare/dundundun.jpg": 63904,
	"./jumpscare/dundundun.mp3": 35379,
	"./jumpscare/genji.jpg": 62966,
	"./jumpscare/genji.mp3": 68677,
	"./jumpscare/herobrine1.mp3": 74495,
	"./jumpscare/herobrine1.webp": 33461,
	"./jumpscare/herobrine2.jpg": 46971,
	"./jumpscare/herobrine2.mp3": 90824,
	"./jumpscare/minecraftZombie2.mp3": 8787,
	"./jumpscare/minecraftZombie2.png": 14820,
	"./logo.png": 33153,
	"./logo/BFBB.webp": 93711,
	"./logo/Balatro.png": 28919,
	"./logo/Banjo-Tooie.png": 29413,
	"./logo/CC.png": 87968,
	"./logo/ChecksMate.png": 64334,
	"./logo/CloneHero.svg": 70565,
	"./logo/Clone_Hero.png": 81528,
	"./logo/Cookie_Clicker.png": 62584,
	"./logo/DSR.webp": 90672,
	"./logo/Golf.png": 458,
	"./logo/Golf_with_your_Friends.png": 5287,
	"./logo/Hades.png": 52747,
	"./logo/Hunie_Cam_Studio.webp": 15439,
	"./logo/Hunie_Pop_2.png": 1484,
	"./logo/MC.png": 84370,
	"./logo/MK64.webp": 31213,
	"./logo/Mario_Kart_64.webp": 20315,
	"./logo/Metin2.png": 73553,
	"./logo/Minecraft.png": 13061,
	"./logo/OC2.png": 38988,
	"./logo/Overcooked.png": 93871,
	"./logo/PKMN.png": 11972,
	"./logo/PKMN_CRYSTAL.webp": 35600,
	"./logo/PKMN_Emerald.webp": 52578,
	"./logo/Pokemon_Crystal.webp": 27613,
	"./logo/Pokemon_Emerald.webp": 50847,
	"./logo/SM64.webp": 18233,
	"./logo/SMW.png": 27587,
	"./logo/Sims.svg": 79022,
	"./logo/Software_Inc.png": 6308,
	"./logo/Specter.png": 14038,
	"./logo/Spectre.png": 19648,
	"./logo/Super_Mario_64.webp": 740,
	"./logo/Super_Mario_World.png": 9301,
	"./logo/Yacht.svg": 14907,
	"./logo/Yacht_Dice.svg": 28123,
	"./minecraft.woff": 99828,
	"./person/Alex.png": 70984,
	"./person/Fausts.webp": 77161,
	"./person/Julia.png": 19129,
	"./person/Kris.png": 68327,
	"./person/LudLud.png": 94606,
	"./person/Ludwig.png": 77682,
	"./person/Masl.png": 55475,
	"./person/Michi.png": 10814,
	"./person/Moritz.png": 5437,
	"./person/Phil.png": 4575,
	"./person/Sarah.png": 78559,
	"./person/Steven.png": 58029,
	"./person/Toni.png": 85800,
	"./pin.png": 16915,
	"./reload.png": 25755,
	"./share.png": 71463,
	"./sounds/firework_2.ogg": 55793,
	"./sounds/firework_3.ogg": 74308,
	"./sounds/firework_4.ogg": 73459,
	"./sounds/firework_5.ogg": 17990,
	"./sounds/firework_6.ogg": 93333,
	"./sounds/firework_7.ogg": 85208,
	"./sounds/firework_start.ogg": 89747,
	"./sounds/steam_achievement.mp3": 94862,
	"./style.css": 85254,
	"./web.png": 22540,
	"./windowsDialoge/calc.webp": 79071,
	"./windowsDialoge/error.png": 23599,
	"./windowsDialoge/fix.png": 84724,
	"./windowsDialoge/localdisk.jpg": 44499,
	"./windowsDialoge/localdisk.png": 38235,
	"./windowsDialoge/pleasereboot.jpg": 49912,
	"./windowsDialoge/taskfailed.jpg": 493,
	"./windowsDialoge/taskfailed.png": 67325,
	"./windowsDialoge/wordpad.gif": 93461,
	"./windowsDialoge/wordpad.png": 35478,
	"./windowsDialoge/xp.mp3": 18966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;